import {
  setDefaultSettings,
  setLayoutSettings
} from 'app/redux/actions/LayoutActions'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { matchPath, useHistory, useLocation } from 'react-router-dom'
import { isMdScreen } from 'utils'
import { valueExistsTS } from 'utilsTS'
import routes from '../../RootRoutes'
import { Layout1SettingsChtcType, LeftSidebarMode } from './Layout1SettingsChtc'

export const useSidebarMode: () => {
  mode: LeftSidebarMode | undefined
  allowClosing: boolean
  updateSidebarMode: (sidebarSettings: Partial<Layout1SettingsChtcType['leftSidebar']>) => void
} = () => {
  const history = useHistory()
  const locationFromRouter = useLocation()

  const settings = useSelector<{
    layout: { settings: { layout1Settings: Layout1SettingsChtcType } }
  }>((state) => state.layout.settings) as {
    layout1Settings: Layout1SettingsChtcType
  }

  const [mode, setMode] = useState<LeftSidebarMode>()

  const currentRoute = routes.find((route) =>
    matchPath(locationFromRouter.pathname, {
      path: route.path,
      exact: false,
      strict: false
    })
  )

  const allowClosing = valueExistsTS(currentRoute?.showCollapseBtn) || isMdScreen()

  const dispatch = useDispatch()

  useEffect(() => {
    const unlisten = history.listen((location: Location) => {
      const matchedRoute = routes.find((route) =>
        matchPath(location.pathname, {
          path: route.path,
          exact: false,
          strict: false
        })
      )

      if (!valueExistsTS(matchedRoute?.showCollapseBtn) && mode === 'close') {
        updateSidebarMode({ mode: 'full' })
      } else if (valueExistsTS(matchedRoute?.collapseByDefault)) {
        updateSidebarMode({ mode: 'close' })
      } else {
        handleResize(settings.layout1Settings.leftSidebar.mode)
        // updateSidebarMode({ mode: settings.layout1Settings.leftSidebar.mode })
      }
    })

    return () => {
      unlisten()
    }
  }, [history, settings.layout1Settings.leftSidebar.mode])

  const updateSidebarMode = (
    sidebarSettings: Partial<Layout1SettingsChtcType['leftSidebar']>
  ): void => {
    const updatedSettings = {
      ...settings,
      layout1Settings: {
        ...settings.layout1Settings,
        leftSidebar: {
          ...settings.layout1Settings.leftSidebar,
          ...sidebarSettings
        }
      }
    }
    setMode(sidebarSettings.mode)
    dispatch(setLayoutSettings(updatedSettings))
    dispatch(setDefaultSettings(updatedSettings))
  }

  const handleResize = (mode?: LeftSidebarMode): void => {
    const windowWidth = window.innerWidth
    if (windowWidth < 1280) {
      updateSidebarMode({ mode: 'close' })
    } else {
      updateSidebarMode({ mode: mode ?? 'full' })
    }
  }

  useEffect(() => {
    window.addEventListener('resize', () => handleResize())
    return () => {
      window.removeEventListener('resize', () => handleResize())
    }
  }, [])

  return {
    mode,
    allowClosing,
    updateSidebarMode
  }
}
